import mime from 'mime'

export function renameFileToMimeType(fileName: string, mimeType: string): string {
  const extension = mime.getExtension(mimeType)
  if (!extension) {
    return fileName
  }
  const dotIndex = fileName.lastIndexOf('.')
  const baseName = dotIndex === -1 ? fileName : fileName.slice(0, dotIndex)
  return `${baseName}.${extension}`
}
